<template>
  <div class="datos">
    <b-modal v-model="vModal">
      <template #modal-header>
        Precio Unitario
      </template>

      <b-input-group prepend="Precio:">
        <b-input autofocus type="number" v-model="selProd.Unidad"></b-input>
      </b-input-group>

      <template #modal-footer>
        <b-button size="sm" squared variant="success" @click="updPrecio">Aceptar</b-button>
      </template>
    </b-modal>
    <b-overlay variant="success" opacity="0.5" :show="Esperar">
      <b-row>
        <b-col>
          <div class="my-1 mx-0 text-center">
            <router-link to="/courier/reportes">
              <img src="/logo4.svg" />
            </router-link>
          </div>
        </b-col>
        <b-col class="pt-2 text-center" cols="8">
          <H3 class="title">Cosolidacion de envio II</H3>
        </b-col>
      </b-row>
      <div v-if="Datos.length">
        <b-table-lite small @row-clicked="OnRowClick" class="tabla" bordered striped :items="MisDatos"></b-table-lite>
        <div class="total">
          <div></div>
          <div class="info">Total:</div>
          <div class="info">{{ GranTotal }}</div>
        </div>
      </div>
      <div v-else>
        <b-alert :show="true"> <b-icon-exclamation /> No hay informacion para mostrar!</b-alert>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

let AgregaProducto = function(arr, item) {
  let aplico = false;

  arr.forEach((prod) => {
    if (prod.Producto == item.Producto) {
      prod.Cantidad = prod.Cantidad + item.Cantidad;
      aplico = true;
    }
  });

  if (!aplico) arr.push(item);
};

export default {
  computed: {
    GranTotal() {
      let envios = this.MisDatos;
      let rs = 0;

      envios.forEach((item) => {
        if (item.Total) rs = rs + item.Total;
      });

      return rs.toFixed(2);
    },
    MisDatos() {
      let envios = this.Datos;
      let precios = this.Viaje.Precios || {};

      envios.forEach((item) => {
        let u = precios[item.Producto] || null;

        item.Unidad = u;
        item.Total = u ? u * item.Cantidad : null;
      });

      return envios;
    },
  },

  methods: {
    updPrecio() {
      let precios = this.Viaje.Precios || {};
      let p = this.selProd;

      precios[p.Producto] = parseFloat(p.Unidad);

      this.Viaje.Precios = precios;

      db.collection("Viaje")
        .doc(this.viaje)
        .update({ Precios: precios })
        .then(() => {
          this.vModal = false;
        });
    },
    OnRowClick(v) {
      this.selProd = { ...v };
      this.vModal = true;
    },
  },
  created() {
    let valor = this.viaje;

    this.$bind("Envios", db.collection("Envios").where("Viaje", "==", valor)).then(() => {
      this.Esperar = false;
    });
  },
  data() {
    return {
      selProd: {},
      Esperar: true,
      Envios: [],
      Datos: [],
      Viaje: {},
      PrecioUnitario: [],
      vModal: false,
      //      campos: ["Guia", "Recibe", "Paquete", "Contenido", "Maleta"],
    };
  },
  watch: {
    async Envios(v) {
      if (v.length > 0) {
        let envs = [];

        v.forEach((item) => {
          item.Contenido.filter((cn) => cn.Tipo == "Paquete").forEach((c, i) => {
            let n = 1 + parseFloat(i);
            if (!item["Pak" + n] == false) {
              c.Contenido.forEach((pak) => {
                if (pak.Salud) {
                  let p = { Cantidad: parseFloat(pak.Cantidad), Producto: pak.Producto };
                  AgregaProducto(envs, p);
                }
              });
            } 
          });
        });
        this.Datos = envs;
      }
    },
  },
  mounted() {
    this.$bind("Viaje", db.collection("Viaje").doc(this.viaje));
  },
  props: ["viaje"],
  beforeCreate() {
    this.$root.$emit("Imprimir", { ok: true });
  },
};
</script>

<style scoped>
.datos {
  width: 19.5cm;
  border: 1p solid black;
}
.tabla {
  font-size: 12px;
  margin-top: 20px;
  margin-bottom: 0px;
}
.total {
  border: 1px solid rgb(222, 226, 230);
  display: table;
  width: 100%;
}

.total > div {
  display: table-cell;
}
.info {
  table-layout: fixed;
  width: 100px;
  text-align: right;
  padding-right: 5px;
}
</style>
